import { memo } from "react";

interface OrgForecastFolderDashedProps {
  size?: number | string;
}

function OrgForecastFolderDashed({ size = 1.5 }: OrgForecastFolderDashedProps) {
  // Convert number to rem (matching @mdi/react Icon behavior where size={1} = 1.5rem)
  const sizeValue = typeof size === "number" ? `${size}rem` : size;

  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 18.5V19H4.5V21H2V18.5H4ZM8.5 19V21H5.5V19H8.5ZM12 18.5V19H12.25V21H9.5V19H10V18.5H12ZM15.583 19V21H13.083V19H15.583ZM18.917 19V21H16.417V19H18.917ZM22 18.5V21H19.75V19H20V18.5H22ZM4 14.5V17.5H2V14.5H4ZM12 14.5V17.5H10V14.5H12ZM22 14.5V17.5H20V14.5H22ZM4 10.5V13.5H2V10.5H4ZM12 10.5V13.5H10V10.5H12ZM22 10.5V13.5H20V10.5H22ZM4 6.5V9.5H2V6.5H4ZM12 6.5V7H12.25V9H12V9.5H10V6.5H12ZM22 7V9.5H20V9H19.75V7H22ZM15.583 7V9H13.083V7H15.583ZM18.917 7V9H16.417V7H18.917ZM4.5 3V5H4V5.5H2V3H4.5ZM12 3V5.5H10V5H9.5V3H12ZM8.5 3V5H5.5V3H8.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(OrgForecastFolderDashed);
